import React from 'react';
import { Check, Quote } from 'lucide-react';
export function SalesLetter() {
  return <section className="py-20 px-4 bg-[#0f0f14]" data-id="element-109">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-110">
        {/* Opening */}
        <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-111">
          <p className="font-medium text-white text-xl" data-id="element-112">
            ¿Sabés lo que es sentir que das todo en una relación y que nunca
            alcanza?
          </p>
          <p data-id="element-113">
            Te entiendo. Pasás noches analizando mensajes, buscando señales
            donde no las hay, y sintiendo esa presión en el pecho que no te deja
            respirar. La ansiedad afectiva no es solo "ser intenso". Es un
            sistema de alerta que nunca se apaga.
          </p>
        </div>

        {/* Quote */}
        <div className="relative p-8 border-l-4 border-[#d4a853] bg-white/5 rounded-r-xl my-12" data-id="element-114">
          <Quote className="absolute top-4 left-4 w-8 h-8 text-[#d4a853]/20" data-id="element-115" />
          <p className="text-xl md:text-2xl font-serif italic text-white relative z-10 pl-6" data-id="element-116">
            "El problema no sos vos. El problema es que nadie te enseñó cómo
            funciona tu sistema emocional."
          </p>
        </div>

        {/* The Problem */}
        <div className="space-y-6 text-gray-300" data-id="element-117">
          <h2 className="text-2xl font-bold text-white mb-4" data-id="element-118">
            La trampa de repetir patrones
          </h2>
          <p data-id="element-119">
            Probablemente ya intentaste de todo. Leíste hilos en Twitter, viste
            videos de 15 segundos en TikTok y escuchaste consejos de amigos como
            "soltá y dejá ir" o "amate más".
          </p>
          <p data-id="element-120">
            Pero esas son frases vacías.{' '}
            <span className="text-[#d4a853] font-semibold" data-id="element-121">
              Nadie te explica el CÓMO.
            </span>
          </p>
          <p data-id="element-122">
            Seguís atrayendo a personas emocionalmente no disponibles, o
            boicoteás relaciones sanas porque la calma te aburre. Es un ciclo
            agotador.
          </p>
        </div>

        {/* The Discovery */}
        <div className="bg-gradient-to-br from-[#1a1a24] to-[#0f0f14] border border-[#d4a853]/30 rounded-2xl p-8 shadow-xl" data-id="element-123">
          <h3 className="text-xl font-bold text-[#d4a853] mb-6 uppercase tracking-wider text-center" data-id="element-124">
            El sistema de 3 pilares
          </h3>
          <div className="grid gap-6" data-id="element-125">
            <div className="flex gap-4" data-id="element-126">
              <div className="w-10 h-10 rounded-full bg-[#d4a853]/20 flex items-center justify-center shrink-0 text-[#d4a853] font-bold" data-id="element-127">
                1
              </div>
              <div data-id="element-128">
                <h4 className="font-bold text-white mb-1" data-id="element-129">
                  Comprensión Profunda
                </h4>
                <p className="text-sm text-gray-400" data-id="element-130">
                  Identificar tu estilo de apego (ansioso, evitativo o
                  desorganizado) para dejar de actuar en piloto automático.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-131">
              <div className="w-10 h-10 rounded-full bg-[#d4a853]/20 flex items-center justify-center shrink-0 text-[#d4a853] font-bold" data-id="element-132">
                2
              </div>
              <div data-id="element-133">
                <h4 className="font-bold text-white mb-1" data-id="element-134">Límites sin Culpa</h4>
                <p className="text-sm text-gray-400" data-id="element-135">
                  Aprender a decir que no y cortar dinámicas dañinas sin sentir
                  que sos una mala persona.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-136">
              <div className="w-10 h-10 rounded-full bg-[#d4a853]/20 flex items-center justify-center shrink-0 text-[#d4a853] font-bold" data-id="element-137">
                3
              </div>
              <div data-id="element-138">
                <h4 className="font-bold text-white mb-1" data-id="element-139">
                  Reconstrucción Interna
                </h4>
                <p className="text-sm text-gray-400" data-id="element-140">
                  Construir seguridad desde adentro para vincularte desde el
                  deseo y no desde la necesidad.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Conclusion */}
        <div className="space-y-6" data-id="element-141">
          <h2 className="text-3xl font-bold text-white" data-id="element-142">
            Por eso nació{' '}
            <span className="text-[#d4a853]" data-id="element-143">Psicología del Apego Moderno</span>
          </h2>
          <ul className="space-y-3" data-id="element-144">
            {['Dejar de perseguir a quien no te elige', 'Entender por qué te aburrís con gente buena', 'Regular tu ansiedad cuando no te contestan', 'Construir una relación donde puedas ser vos'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-300" data-id="element-145">
                <Check className="w-5 h-5 text-[#d4a853]" data-id="element-146" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}